<template>
  <div class="sidebar-area">
    <div class="logo position-relative">
      <a href="/" class="d-block text-decoration-none position-relative">
        <img
          src="@/assets/images/logos/LOGO-1.png"
          alt="logo-icon"
          class="logo-icon"
          max-width="60"
          width="45"
          height="auto"
        />
        <span class="logo-text fw-bold text-dark">MERO PRINTS</span>
      </a>
      <button
        class="sidebar-burger-menu bg-transparent p-0 border-0 opacity-0 z-n1 position-absolute top-50 end-0 translate-middle-y"
        id="sidebar-burger-menu"
        @click="stateStoreInstance.onChange"
      >
        <i data-feather="x"></i>
      </button>
    </div>

    <div class="layout-menu menu-vertical menu hover-scroll-bar">
      <ul class="menu-inner">
        <!-- <li class="menu-title small text-uppercase">
          <span class="menu-title-text">MAIN</span>
        </li> -->
        <li class="menu-item" :class="{ open: isOpen('dashboard') }">
          <RouterLink to="/dashboard" class="menu-link">
            <span class="material-symbols-outlined menu-icon">dashboard</span>
            <span class="title">Dashboard</span>
          </RouterLink>
        </li>
        <li class="menu-title small text-uppercase">
          <span class="menu-title-text ">USER INTERFACE</span>
        </li>
        <li class="menu-item">
          <RouterLink to="/school-detail/" class="menu-link">
            <span class="material-symbols-outlined menu-icon ">school</span>
            <span class="title">School Details</span>
          </RouterLink>
        </li>
        <li class="menu-item">
          <RouterLink to="/class-info/" class="menu-link">
            <span class="material-symbols-outlined menu-icon ">class</span>
            <span class="title">Class Details</span>
          </RouterLink>
        </li>
        <li class="menu-item">
          <RouterLink to="/promote-class/" class="menu-link">
            <span class="material-symbols-outlined menu-icon ">group_add</span>
            <span class="title">Promote Class</span>
          </RouterLink>
        </li>
        <li class="menu-item">
          <RouterLink to="/archived_student/" class="menu-link">
            <span class="material-symbols-outlined menu-icon ">group_add</span>
            <span class="title">Migrated Student </span>
          </RouterLink>
        </li>
        <li class="menu-item">
          <RouterLink to="/employeeDetail/" class="menu-link">
            <span class="material-symbols-outlined menu-icon ">badge</span>
            <span class="title">Employee Details</span>
          </RouterLink>
        </li>
        <li class="menu-item" :class="{ open: isOpen('uploads') }">
          <a
            href="javascript:void(0);"
            class="menu-link menu-toggle"
            @click="toggleMenu('uploads')"
          >
            <span class="material-symbols-outlined menu-icon ">upload</span>
            <span class="title">Upload</span>
          </a>

          <ul class="menu-sub" v-show="isOpen('uploads')">
            <li class="menu-item">
              <RouterLink to="/uploadFile" class="menu-link">
                <span class="material-symbols-outlined menu-icon ">add_photo_alternate</span>
                Image Upload
              </RouterLink>
            </li>
            <li class="menu-item">
              <RouterLink to="/uploadFile/student" class="menu-link">
                <span class="material-symbols-outlined menu-icon ">group_add</span>
                Student Upload
              </RouterLink>
            </li>
            <li class="menu-item">
              <RouterLink to="/uploadFile/employee" class="menu-link">
                <span class="material-symbols-outlined menu-icon ">supervisor_account</span>
                Employee Upload
              </RouterLink>
            </li>
          </ul>
        </li>
        <li class="menu-item">
          <RouterLink to="/user-list" class="menu-link">
            <span class="material-symbols-outlined menu-icon ">person_add</span>
            <span class="title">Add User</span>
          </RouterLink>
        </li>
        <li class="menu-item">
          <RouterLink to="/upload-roll-num/" class="menu-link">
            <span class="material-symbols-outlined menu-icon ">group_add</span>
            <span class="title">Update Roll Number</span>
          </RouterLink>
        </li>
        <!-- <li class="menu-item">
          <RouterLink to="/cardSample" class="menu-link">
            <span class="material-symbols-outlined menu-icon ">credit_card</span>
            <span class="title">ID Card</span>
          </RouterLink>
        </li> -->
        <li class="menu-item">
          <RouterLink to="/generate-id-card" class="menu-link">
            <span class="material-symbols-outlined menu-icon ">credit_card</span>
            <span class="title">ID Card</span>
          </RouterLink>
        </li>
        <!-- <li class="menu-item">
          <RouterLink
            to="/authentication/login"
            class="menu-link"
            @click="handleLogout"
          >
            <span class="material-symbols-outlined menu-icon">logout</span>
            <span class="title">Logout</span>
          </RouterLink>
        </li> -->
      </ul>
    </div>
  </div>
</template>

<script>
import logo from "@/assets/images/logos/LOGO-3.png";
import { defineComponent, ref, onMounted } from "vue";
import feather from "feather-icons";
import stateStore from "../../utils/store";
import { logout } from "@/services/apiServices";
export default defineComponent({
  name: "LeftSidebar",
  setup() {
    const stateStoreInstance = stateStore;

    // Reactive state to track which menu items are open
    const openMenu = ref(null);

    // Method to toggle the menu items
    const toggleMenu = (menu) => {
      // If the same menu is clicked, toggle it; otherwise, open the clicked menu
      openMenu.value = openMenu.value === menu ? null : menu;
    };

    // Method to check if a menu is open
    const isOpen = (menu) => {
      return openMenu.value === menu;
    };

    const handleLogout = async () => {
      try {
        localStorage.clear();
        sessionStorage.clear(); // Optionally clear sessionStorage if necessary

        // Redirect to login page
        router.replace("/authentication/login");;
      } catch (error) {
        console.error("Logout failed:", error);
        // Handle the error (optional: show an error message to the user)
      }
    };

    onMounted(() => {
      feather.replace();
    });

    return {
      stateStoreInstance,
      handleLogout,
      toggleMenu,
      isOpen,
    };
  },
});
</script>

<style >
.logo-icon {
  border: 2px solid #c2cdff;
  display: block;
  /* border-radius: 8px; */
  border-radius: 50%;
}
</style>
